import { render, staticRenderFns } from "./ListCheckBox.global.vue?vue&type=template&id=2517fd86&scoped=true&lang=pug&"
import script from "./ListCheckBox.global.vue?vue&type=script&lang=ts&"
export * from "./ListCheckBox.global.vue?vue&type=script&lang=ts&"
import style0 from "./ListCheckBox.global.vue?vue&type=style&index=0&id=2517fd86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2517fd86",
  null
  
)

export default component.exports